var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{style:(_vm.cssVars),attrs:{"height":"100%","disabled":_vm.disabled,"ripple":false,"text":""}},[_c('v-icon',{attrs:{"dark":"","size":"105"}},[_vm._v(" "+_vm._s(this.icon)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }